import { createSlice } from '@reduxjs/toolkit'

type initialStateInterface = {
  loading: boolean,
  flag: any, // null, true or false
  data: object,
  message: string
};

const initialState: initialStateInterface = {
  loading: false,
  flag: null,
  data: {},
  message: "",
};

const slice = createSlice({
  name: 'common/affirmation',
  initialState: initialState,
  reducers: {
    fetchAffirmationOfTheDayRequest: (state, action) => {
      return { ...state, loading: true, flag: null, message: "" };
    },
    fetchAffirmationOfTheDaySuccess: (state, { payload }) => {
      return {
        ...state,
        loading: false,
        flag: true,
        data: (payload.data || {})
      };
    },
    fetchAffirmationOfTheDayFailed: (state, { payload }) => {

      // Adding fallback quotes of the day if anything goes wrong while fetching quotes
      return {
        ...state,
        loading: false,
        flag: false,
        data: ({})
      };
    },
    fetchAffirmationOfTheDayReset: (state) => {
      return initialState;
    }
  }
});

// Actions
export const {
  fetchAffirmationOfTheDayRequest, fetchAffirmationOfTheDaySuccess, fetchAffirmationOfTheDayFailed, fetchAffirmationOfTheDayReset,
} = slice.actions;

// Reducers
export default slice.reducer;
